<template>

  <div class="pb">
    
    <UiButton
      :name="'modal 1'"
      type="primary"
      @click.native="active = true"
    />
    

    <UiModal
      :title="'New week type'"   
      :close-button-name="close"
      :is-transparent="true"
      :is-auto-height="true"
      :width="'70%'"
      :max-width="'400px'"
      @close="active = false"      
      v-if="active"   
      >        
          
      <UiButton
        :name="'modal 2'"
        type="primary"
        @click.native="active2 = true"
      />
      
      
    </UiModal>

    <UiModal
      :title="'New week type'"   
      :close-button-name="close"
      :is-transparent="false"
      :is-auto-height="true"
      :width="'70%'"
      :max-width="'400px'"
      @close="active2 = false"      
      v-if="active2"   
      >        
        
      hello
      
    </UiModal>



  </div>

</template>

<script setup lang="ts">

const active = ref(false)
const active2 = ref(false)

</script>

<style scoped>

.text-style-info{
    text-indent: 2rem;
}

.html_into :v-deep(.de_im){
  height: 14px;
  vertical-align: middle;
}

.tg{
  margin-top: 10px;
}
 
 
</style>